import { j as r } from "./jsx-runtime-944c88e2.js";
import { T as p } from "./chunk-2OOHT3W5-81d8ab81.js";
import { u as f, T as u, Y as b } from "./eMyAsurionProvider-d8e4d830.js";
import { B as e } from "./cleave-react-node-c4a374e5.js";
import { RadioGroup as j, Radio as g } from "@chakra-ui/react";
import { useState as S } from "react";
import "@chakra-ui/icons";
import "./useAccount-2421e215.js";
import "./myasurion-shared.mixpanel.es.js";
import "./features-d3d4bb45.js";
import "@tanstack/react-query";
import "./providers-251f5186.js";
import "react-router-dom";
import "./lodash-9598aa3c.js";
import "@react-oauth/google";
import "./chunk-DMO4EI7P-a11dff68.js";
import "@emotion/react";
import "./domains-bf220bf9.js";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
import "@emotion/styled";
const Q = ({
  question: s,
  deliveryTypes: t,
  onNextClick: m
  // ...props
}) => {
  const [i, a] = S(""), n = "DeliveryOptions", { data: l } = f(), { theme: x } = l, { colors: c } = x, { bodyTextColor: d } = c, h = (o) => {
    m && m(o);
  };
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsxs(e, { fontFamily: "Apercu Pro", children: [
    /* @__PURE__ */ r.jsx(
      p,
      {
        fontSize: "32px",
        fontWeight: 300,
        mb: 4,
        textAlign: { base: "start", lg: "center" },
        children: /* @__PURE__ */ r.jsx(u, { text: s, translationKey: `${n}/question` })
      }
    ),
    /* @__PURE__ */ r.jsx(e, { w: { base: "full", lg: "60%" }, mx: "auto", children: /* @__PURE__ */ r.jsx(
      j,
      {
        onChange: (o) => {
          a(o);
        },
        value: i,
        children: /* @__PURE__ */ r.jsx(b, { children: t == null ? void 0 : t.map((o) => /* @__PURE__ */ r.jsx(
          e,
          {
            borderWidth: "1px",
            borderRadius: "md",
            fontSize: "20px",
            borderColor: o.label == i ? d : "#A5AAAF",
            border: o.label == i ? "2px" : "",
            p: 4,
            mb: 4,
            children: /* @__PURE__ */ r.jsx(
              g,
              {
                fontSize: "20px",
                size: "lg",
                value: o.label,
                colorScheme: "primary",
                onChange: () => {
                  h(o.key);
                },
                children: /* @__PURE__ */ r.jsx(p, { fontSize: "20px", children: o.label })
              },
              o.key
            )
          },
          o.key
        )) })
      }
    ) })
  ] }) });
};
export {
  Q as DeliveryOptions
};
